// extracted by css-extract-rspack-plugin
export default {"wrapper":"_97714bb4","dropdown":"_f6ed163c","isVisible":"_d33cb933","bodyWrapper":"_1ed3a104"};